/** Legacy v1 scenario name -> path under /version-2/scenarios/solar-system/ */
module.exports = {
  "The Solar System": "planets/the-solar-system",
  "The Inner Solar System": "planets/the-inner-solar-system",
  "Pentagram of Venus": "planets/pentagram-of-venus",
  "The Sun, Earth and Moon System": "moons/the-earth-and-moon-system",
  "Mars and Its Moons Phobos and Deimos":
    "moons/mars-and-its-moons-phobos-and-deimos",
  "Jupiter and Its Galilean Moons": "moons/jupiter-and-the-galilean-moons",
  "Saturn and Its Rings and Major Moons": "moons/saturn-and-its-moons",
  "Uranus and Its Rings and Major Moons": "moons/uranus-and-its-moons",
  "Neptune and Its Major Moons": "moons/neptune-and-its-moons",
  "Pluto and Its Five Moons": "moons/pluto-and-its-moons",
  "Eris and Dysnomia": "moons/eris-and-dysnomia",
  "Shoemaker-Levy 9 Impacts Jupiter": "moons/shoemaker-levy-9-impacts-jupiter",
  "Apophis 2029 Earth Encounter":
    "asteroids/the-2029-apophis-close-encounter-with-earth",
  "Twenty-two Largest Potentially Hazardous Near Earth Asteroids":
    "asteroids/the-largest-near-earth-asteroids",
  "Jupiter and Its Ten Largest Trojan Asteroids":
    "asteroids/jupiter-and-its-ten-largest-trojan-asteroids",
  "Earth's Trojan Asteroids": "asteroids/earth's-trojan-asteroids",
  "The Centaur Asteroids and Comets": "asteroids/the-largest-centaurs",
  "Short Period (Jupiter Family) Comets":
    "comets/notable-short-period-comets",
  "Interstellar Asteroid Oumuamua":
    "interstellar-objects/interstellar-asteroid-oumuamua",
  "Interstellar Comet Borisov":
    "interstellar-objects/interstellar-comet-borisov",
};
